/*
 * Glow House — product page behaviour (main-product + product-* sections).
 * Vanilla, loaded with defer. Delegated events where possible; per-section init on load and on shopify:section:load.
 */
(function () {
  'use strict';

  if (window.GHProduct) return;
  var GH = (window.GH = window.GH || {});

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------ money */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || (GH.settings && GH.settings.moneyFormat) || '€{{amount_with_comma_separator}}';
    function fmt(number, precision, thousands, decimal) {
      thousands = typeof thousands === 'undefined' ? ',' : thousands;
      decimal = typeof decimal === 'undefined' ? '.' : decimal;
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return fmt(cents, 2);
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2, '.', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }

  /* ---------------------------------------------------------------- gallery */
  function initGallery(gallery) {
    if (!gallery || gallery.__ghInit) return;
    gallery.__ghInit = true;
    var track = $('[data-gallery-track]', gallery);
    if (!track) return;
    var slides = $$('.gh-pdp-gallery__slide', track);
    var thumbs = $$('[data-gallery-thumb]', gallery);
    var dots = $$('.gh-pdp-gallery__dot', gallery);
    var counter = $('[data-gallery-index]', gallery);
    var current = -1;

    function setActive(i) {
      if (i === current) return;
      current = i;
      if (counter) counter.textContent = i + 1;
      // Badges only belong on the first photo
      gallery.classList.toggle('is-past-first', i > 0);
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      slides.forEach(function (s, n) {
        if (n !== i) {
          var v = $('video', s);
          if (v && !v.paused) v.pause();
        }
      });
      var active = thumbs[i];
      if (active && active.parentElement && active.parentElement.scrollHeight > active.parentElement.clientHeight) {
        var p = active.parentElement;
        var top = active.offsetTop - p.offsetTop;
        if (top < p.scrollTop || top + active.offsetHeight > p.scrollTop + p.clientHeight) p.scrollTop = top - 10;
      }
    }
    function goTo(i, instant) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: instant || reduceMotion ? 'auto' : 'smooth' });
      setActive(i);
    }
    gallery.__goTo = goTo;
    gallery.__goToMedia = function (mediaId, instant) {
      if (!mediaId) return;
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) { goTo(i, instant); return; }
      }
    };

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var w = track.clientWidth || 1;
        setActive(Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w))));
      });
    }, { passive: true });

    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (thumb) { goTo(parseInt(thumb.getAttribute('data-gallery-thumb'), 10)); return; }
      if (e.target.closest('[data-gallery-prev]')) { goTo(current - 1); return; }
      if (e.target.closest('[data-gallery-next]')) { goTo(current + 1); }
    });
    track.addEventListener('keydown', function (e) {
      if (e.target !== track) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
    });

    var start = parseInt(gallery.getAttribute('data-start'), 10) || 0;
    current = -1;
    if (start > 0) goTo(start, true); else setActive(0);

    if ($('model-viewer', gallery) && window.Shopify && Shopify.loadFeatures) {
      Shopify.loadFeatures([{
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: function (err) {
          if (err || !window.Shopify.ModelViewerUI) return;
          $$('model-viewer', gallery).forEach(function (mv) { new Shopify.ModelViewerUI(mv); });
        }
      }]);
    }
  }

  /* --------------------------------------------------------- variant picker */
  function initPdp(root) {
    if (!root || root.__ghInit) return;
    root.__ghInit = true;
    var sectionId = root.getAttribute('data-section-id');
    var formId = root.getAttribute('data-form-id');
    var form = document.getElementById(formId);
    var variantsEl = $('script[data-variants]', root);
    var variants = [];
    try { variants = variantsEl ? JSON.parse(variantsEl.textContent) : []; } catch (e) { variants = []; }
    var gallery = $('[data-gallery]', root);
    initGallery(gallery);

    var atcTemplate = root.getAttribute('data-atc-template') || '[price]';
    var plainLabel = root.getAttribute('data-atc-plain') || '';
    var productId = root.getAttribute('data-product-id');
    var pending = null;

    function qty() {
      var input = document.querySelector('input[name="quantity"][form="' + formId + '"]') || (form && $('input[name="quantity"]', form));
      var q = input ? parseInt(input.value, 10) : 1;
      return isNaN(q) || q < 1 ? 1 : q;
    }

    /* Kaching Bundles (app embed) injects its widget into the buy form and sets the form's id/quantity itself.
       The cart is then charged the selected bundle total, so the buttons may only show that total (read from the
       selected Kaching bar) or no price at all, never the 1-unit theme price. */
    function kachingEl() {
      return form ? form.querySelector('kaching-bundle, kaching-bundles-block, .kaching-bundles__block') : null;
    }
    function kachingActive() {
      if (kachingEl()) return true;
      // The embed announces itself in <head> before the widget mounts; treat the product as Kaching-managed from the start.
      return !!(window.kachingBundlesEnabled && productId &&
        document.querySelector('.kaching-bundles-deal-block-settings[data-product-id="' + productId + '"]'));
    }
    function parseMoneyText(txt) {
      var s = String(txt || '').replace(/[^\d.,]/g, '');
      if (!/\d/.test(s)) return null;
      var m = s.match(/^(.*?)[.,](\d{2})$/);
      var cents = m ? (parseInt(m[1].replace(/[.,]/g, '') || '0', 10) * 100) + parseInt(m[2], 10) : parseInt(s.replace(/[.,]/g, ''), 10) * 100;
      return isNaN(cents) ? null : cents;
    }
    function unitPrices() {
      var prices = variants.map(function (v) { return parseInt(v.price, 10); }).filter(function (p) { return !isNaN(p) && p > 0; });
      return prices.length ? { min: Math.min.apply(null, prices), max: Math.max.apply(null, prices) } : null;
    }
    // Selected bundle total in cents, or null when it can't be read reliably.
    function kachingTotal() {
      var k = kachingEl();
      if (!k) return null;
      var selected = k.querySelectorAll('.kaching-bundles__bar--selected');
      if (selected.length !== 1) return null;
      var priceEl = selected[0].querySelector('.kaching-bundles__bar-price');
      var total = priceEl ? parseMoneyText(priceEl.textContent) : null;
      if (!total) return null;
      // Sanity check against the variant prices x bundle quantity: rejects per-unit prices and anything implausible.
      var range = unitPrices();
      // Bundle size: the form quantity, or the number of per-item variant selects (mixed-variant bundles keep quantity=1).
      var q = Math.max(qty(), selected[0].querySelectorAll('select.kaching-bundles__bar-variant-select').length);
      if (!range || total > range.max * q + 1 || total < range.min * q * 0.5) return null;
      var fullEl = selected[0].querySelector('.kaching-bundles__bar-full-price');
      var full = fullEl ? parseMoneyText(fullEl.textContent) : null;
      return { total: total, full: full && full > total ? full : null };
    }

    function setText(el, text) { if (el && el.textContent !== text) el.textContent = text; }
    function labelFor(cents) { return cents === null ? plainLabel : atcTemplate.replace('[price]', formatMoney(cents)); }

    function updateAtcLabels() {
      var q = qty();
      var kaching = kachingActive();
      var bundle = kaching ? kachingTotal() : null;
      $$('[data-pdp-atc]', root).forEach(function (btn) {
        if (btn.disabled) return;
        var showPrice = btn.getAttribute('data-show-price') === 'true';
        if (kaching) { setText(btn, showPrice && bundle ? labelFor(bundle.total) : plainLabel); return; }
        if (!showPrice) return;
        setText(btn, labelFor(parseInt(btn.getAttribute('data-price'), 10) * q));
      });
      $$('[data-pdp-sticky-atc] [data-atc-price-label]', root).forEach(function (label) {
        var btn = label.closest('[data-pdp-sticky-atc]');
        if (kaching) setText(label, bundle ? labelFor(bundle.total) : plainLabel);
        else setText(label, labelFor(parseInt(btn.getAttribute('data-price'), 10) * q));
      });
      $$('[data-swap="sticky-price"]', root).forEach(function (el) {
        if (!kaching) { el.hidden = false; return; }
        if (!bundle) { el.hidden = true; return; }
        el.hidden = false;
        setText($('strong', el), formatMoney(bundle.total));
        var was = $('s', el);
        if (bundle.full) {
          if (!was) {
            was = document.createElement('s');
            was.innerHTML = '<span class="visually-hidden"></span><span data-was></span>';
            el.appendChild(was);
          }
          var wasLabel = $('.visually-hidden', was);
          if (wasLabel && !wasLabel.textContent) wasLabel.textContent = root.getAttribute('data-regular-price') || '';
          var wasVal = $('[data-was]', was);
          if (wasVal) setText(wasVal, formatMoney(bundle.full));
          else was.lastChild.textContent = formatMoney(bundle.full);
          was.hidden = false;
        } else if (was) {
          was.hidden = true;
        }
      });
    }

    function selectedOptions() {
      return $$('[data-option]', root).map(function (fs) {
        var checked = $('input[data-option-input]:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    function setUnavailable() {
      var label = root.getAttribute('data-unavailable');
      $$('[data-pdp-atc], [data-pdp-sticky-atc]', root).forEach(function (btn) {
        btn.disabled = true;
        btn.textContent = label;
      });
    }

    function swap(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      $$('[data-swap]', root).forEach(function (el) {
        var key = el.getAttribute('data-swap');
        var fresh = doc.querySelector('[data-swap="' + key + '"]');
        if (fresh) el.replaceWith(fresh);
      });
      updateAtcLabels();
    }

    function onChange() {
      var opts = selectedOptions();
      var variant = findVariant(opts);
      $$('[data-option]', root).forEach(function (fs, i) {
        var label = $('legend [data-swap]', fs);
        if (label && opts[i] !== null) label.textContent = opts[i];
      });
      if (!variant) { setUnavailable(); return; }

      var idInput = idField();
      if (idInput) {
        idInput.value = variant.id;
        lastId = String(variant.id);
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      applyVariant(variant.id);
    }

    function idField() { return form ? $('input[name="id"]', form) : null; }
    function variantById(id) {
      for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(id)) return variants[i]; }
      return null;
    }

    // URL, gallery, button prices and a server-rendered swap of price/stock/badges/sticky bar for the given variant id.
    function applyVariant(id) {
      var variant = variantById(id);
      lastId = String(id);
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        history.replaceState(history.state, '', url.toString());
      }
      if (variant && variant.media && gallery && gallery.__goToMedia) gallery.__goToMedia(variant.media);

      // Optimistic price update in the buttons, then server-rendered swap of price/stock/options.
      if (variant) $$('[data-pdp-atc], [data-pdp-sticky-atc]', root).forEach(function (btn) { btn.setAttribute('data-price', variant.price); });
      updateAtcLabels();
      root.classList.add('is-loading');

      if (pending) pending.abort();
      pending = window.AbortController ? new AbortController() : null;
      var src = (root.getAttribute('data-product-url') || window.location.pathname) + '?variant=' + encodeURIComponent(id) + '&section_id=' + encodeURIComponent(sectionId);
      fetch(src, pending ? { signal: pending.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          swap(html);
          root.classList.remove('is-loading');
          document.dispatchEvent(new CustomEvent('gh:variant:change', { detail: { sectionId: sectionId, variant: variant || { id: Number(id) } } }));
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          root.classList.remove('is-loading');
        });
    }

    /* Apps such as Kaching set the form's input[name=id] (and quantity) via JS, often only as a .value property,
       so watch it three ways: attribute mutations / widget re-renders, 'change' events and a light poll. */
    var initialId = idField();
    var lastId = initialId ? String(initialId.value) : '';
    var lastSig = '';
    function syncFromForm() {
      if (!root.isConnected) { stopSync(); return; }
      var input = idField();
      var id = input ? String(input.value) : '';
      if (id && /^\d+$/.test(id) && id !== lastId) { applyVariant(id); return; }
      var k = kachingEl();
      var sig = id + '|' + qty() + '|' + (k ? k.querySelectorAll('.kaching-bundles__bar--selected').length + ':' + ((k.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-price') || {}).textContent || '') : '-');
      if (sig !== lastSig) { lastSig = sig; updateAtcLabels(); }
    }
    var syncTimer = null;
    function queueSync() { if (!syncTimer) syncTimer = setTimeout(function () { syncTimer = null; syncFromForm(); }, 60); }
    var formObserver = null;
    var pollId = null;
    function stopSync() {
      if (formObserver) formObserver.disconnect();
      if (pollId) clearInterval(pollId);
      formObserver = null; pollId = null;
    }
    if (form) {
      if ('MutationObserver' in window) {
        formObserver = new MutationObserver(queueSync);
        formObserver.observe(form, { attributes: true, attributeFilter: ['value', 'class'], childList: true, subtree: true, characterData: true });
      }
      form.addEventListener('change', queueSync);
      form.addEventListener('input', queueSync);
      pollId = setInterval(syncFromForm, 700);
      root.__ghStopSync = stopSync;
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-input]')) onChange();
      if (e.target.matches('input[name="quantity"]')) updateAtcLabels();
    });
    root.addEventListener('input', function (e) {
      if (e.target.matches('input[name="quantity"]')) updateAtcLabels();
    });

    if (kachingActive() || document.querySelector('input[name="quantity"][form="' + formId + '"]')) updateAtcLabels();
    initSticky(root, form);
  }

  /* ------------------------------------------------------------ sticky bar */
  function initSticky(root, form) {
    var bar = $('[data-pdp-sticky]', root);
    if (!bar || !form || !('IntersectionObserver' in window)) return;
    function show(on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      document.body.classList.toggle('gh-sticky-atc', on);
      // Real bar height (incl. the iPhone safe area) so floating buttons such as the scratch-card tab sit above it.
      if (on) document.documentElement.style.setProperty('--gh-sticky-h', bar.offsetHeight + 'px');
    }
    window.addEventListener('resize', function () {
      if (bar.classList.contains('is-visible')) document.documentElement.style.setProperty('--gh-sticky-h', bar.offsetHeight + 'px');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Show once the buy button has scrolled out above the viewport.
        show(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    });
    io.observe(form);
    root.__ghStickyIO = io;
  }

  /* ---------------------------------------------------------------- reviews */
  function openReviews(trigger) {
    var dialog = $('[data-reviews-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    dialog.__opener = trigger || document.activeElement;
    dialog.showModal();
    document.body.classList.add('gh-locked');
    return true;
  }
  function closeReviews(dialog) {
    if (dialog && dialog.open) dialog.close();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var trigger = t.closest('[data-reviews-trigger], [data-reviews-open]');
    if (trigger) {
      if (openReviews(trigger)) e.preventDefault();
      return;
    }
    var close = t.closest('[data-reviews-close]');
    if (close) { closeReviews(close.closest('dialog')); return; }
    if (t.matches && t.matches('dialog[data-reviews-dialog]')) {
      // Click on the backdrop (outside the dialog box).
      var r = t.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeReviews(t);
      return;
    }
    var more = t.closest('button[data-reviews-more]');
    if (more) {
      var list = more.closest('[data-reviews-dialog]');
      var hidden = $$('[data-reviews-item][hidden], [data-review-more][hidden]', list);
      var step = parseInt(more.getAttribute('data-step'), 10) || 5;
      var shown = hidden.slice(0, step);
      shown.forEach(function (li) { li.hidden = false; });
      if (hidden.length <= step) {
        var href = more.getAttribute('data-href');
        if (href) {
          // Everything is visible: the button becomes the "see all reviews" link.
          var a = document.createElement('a');
          a.className = more.className;
          a.href = href;
          a.textContent = more.textContent;
          more.parentNode.replaceChild(a, more);
        } else {
          more.parentElement.hidden = true;
          // Keep focus inside the dialog: move it to the first revealed review.
          if (shown[0]) shown[0].focus({ preventScroll: true });
        }
      }
      return;
    }
    var share = t.closest('[data-reviews-share]');
    if (share) {
      var url = window.location.href.split('#')[0] + '#gh-reviews';
      if (navigator.share) {
        navigator.share({ title: document.title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          share.setAttribute('data-copied', '');
          setTimeout(function () { share.removeAttribute('data-copied'); }, 1600);
        }).catch(function () {});
      }
      return;
    }
    var like = t.closest('[data-like]');
    if (like) {
      var on = like.getAttribute('aria-pressed') !== 'true';
      like.setAttribute('aria-pressed', on ? 'true' : 'false');
      var card = like.closest('.gh-fbc__card');
      var count = card && $('[data-like-count]', card);
      if (count) {
        var base = count.__base || (count.__base = count.textContent);
        var n = parseInt(String(base).replace(/\D/g, ''), 10);
        if (!isNaN(n)) count.textContent = on ? String(n + 1) : base;
      }
      return;
    }
    var pick = t.closest('[data-routine-pick]');
    if (pick) {
      var routine = pick.closest('[data-routine]');
      var steps = $$('[data-routine-step]', routine);
      selectRoutine(routine, steps.indexOf(pick.closest('[data-routine-step]')));
      return;
    }
    var rNav = t.closest('[data-routine-prev], [data-routine-next]');
    if (rNav) {
      var rt = rNav.closest('[data-routine]');
      var cur = rt.__sel || 0;
      selectRoutine(rt, cur + (rNav.hasAttribute('data-routine-prev') ? -1 : 1));
    }
  });
  document.addEventListener('close', function (e) {
    var d = e.target;
    if (!d.matches || !d.matches('[data-reviews-dialog]')) return;
    document.body.classList.remove('gh-locked');
    if (d.__opener && d.__opener.focus) d.__opener.focus();
  }, true);

  /* ---------------------------------------------------------------- routine */
  function selectRoutine(routine, i) {
    if (!routine) return;
    var steps = $$('[data-routine-step]', routine);
    if (!steps.length) return;
    i = Math.max(0, Math.min(steps.length - 1, i));
    routine.__sel = i;
    steps.forEach(function (s, n) {
      s.classList.toggle('is-selected', n === i);
      var b = $('[data-routine-pick]', s);
      if (b) b.setAttribute('aria-pressed', n === i ? 'true' : 'false');
    });
    var track = $('[data-routine-track]', routine);
    var step = steps[i];
    if (track && step) track.style.setProperty('--routine-x', -(step.offsetLeft + step.offsetWidth / 2) + 'px');
    var prev = $('[data-routine-prev]', routine);
    var next = $('[data-routine-next]', routine);
    if (prev) prev.disabled = i === 0;
    if (next) next.disabled = i === steps.length - 1;
  }
  function initRoutine(routine) {
    if (!routine || routine.__ghInit) return;
    routine.__ghInit = true;
    var steps = $$('[data-routine-step]', routine);
    var sel = 0;
    steps.forEach(function (s, n) { if (s.classList.contains('is-selected')) sel = n; });
    selectRoutine(routine, sel);
    // Swipe on touch devices.
    var x0 = null;
    routine.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    routine.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) selectRoutine(routine, (routine.__sel || 0) + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }
  window.addEventListener('resize', function () {
    $$('[data-routine]').forEach(function (r) { selectRoutine(r, r.__sel || 0); });
  });

  /* ------------------------------------------------------------- UGC videos */
  var videoIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var v = entry.target;
      if (entry.isIntersecting) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { threshold: 0.4 }) : null;
  function initVideos(section) {
    if (!section || section.__ghInit) return;
    section.__ghInit = true;
    $$('.gh-ugc__media video', section).forEach(function (v) {
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.loop = true;
      if (reduceMotion) { v.controls = true; return; }
      if (videoIO) videoIO.observe(v);
    });
  }

  /* -------------------------------------------------------- recommendations */
  function initRecommendations(el) {
    if (!el || el.__ghInit) return;
    var url = el.getAttribute('data-url');
    if (!url) return;
    el.__ghInit = true;
    if (el.querySelector('[data-carousel-track]')) { if (GH.carousels) GH.carousels.update(el); return; }
    function load() {
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) {
            el.innerHTML = fresh.innerHTML;
            if (GH.carousels) GH.carousels.update(el);
            if (GH.favorites && GH.favorites.sync) GH.favorites.sync();
          }
        })
        .catch(function () {});
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); }
      }, { rootMargin: '0px 0px 600px 0px' });
      io.observe(el);
    } else {
      load();
    }
  }

  /* ------------------------------------------------------------------- init */
  function init(scope) {
    scope = scope || document;
    $$('[data-pdp]', scope).forEach(initPdp);
    $$('[data-routine]', scope).forEach(initRoutine);
    $$('[data-ugc]', scope).forEach(initVideos);
    $$('[data-recommendations]', scope).forEach(initRecommendations);
  }

  window.GHProduct = { init: init, formatMoney: formatMoney, openReviews: openReviews };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    $$('[data-pdp]', e.target).forEach(function (root) {
      if (root.__ghStickyIO) root.__ghStickyIO.disconnect();
      if (root.__ghStopSync) root.__ghStopSync();
      document.body.classList.remove('gh-sticky-atc');
    });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var step = e.target.closest && e.target.closest('[data-routine-step]');
    if (step) {
      var routine = step.closest('[data-routine]');
      selectRoutine(routine, $$('[data-routine-step]', routine).indexOf(step));
    }
  });
})();
